module.exports = __webpack_public_path__ + "static/img/index-p1.274578c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-p1.png
// module id = hDJt
// module chunks = 1